module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/apple-7de8a73255b3d477c0520d1c59916349.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/apple.svg
// module id = Dknm
// module chunks = 24